import { Component } from 'react';
import key from 'weak-key';
import _ from 'lodash';

/**
 * Location List
 * @category Component
 * @extends Component
 * @summary Display a single location.
 * @prop {string} zip - The zip code if searching.
 * @return {Node} React node containing a single location.
 */

class LocationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        'Location',
        'Station',
        'Air Time',
      ]
    };
  }

  render() {
    const { headers } = this.state;
    const { data, getAll } = this.props;

    if(data) {
      // Group these by state
      const stateGroups = _.chain(data.showfinderQuery.results)
        .groupBy('state')
        .map((cities, state) => ({ cities, state }))
        .filter(group => group.state !== 'null')
        .value();

      if(stateGroups.length) {
        return (
          <>
            <div className='locations'>
              <div className='locations__content'>
                <div className='locations__row locations__row--header'>
                  {headers.map((col) =>
                    <div className='cell' key={`header-${col}`}>
                      { col }
                    </div>
                  )}
                </div>
                  {stateGroups.map((location) => (
                    <div key={`location-${key(location)}`}>
                      <h3 className='locations__state'>{ location.state }</h3>
                      {location.cities.map((city) =>
                        <div className='locations__row' key={`city-${key(city)}`}>
                          <div className='cell'>
                            { city.city &&
                              <div>
                                <h4>City</h4>
                                { city.city }
                              </div>
                            }
                          </div>
                          <div className='cell'>
                            { city.affiliate &&
                              <div>
                                <h4>Station</h4>
                                { city.affiliate }
                              </div>
                            }
                          </div>
                          <div className='cell'>
                            { city.time &&
                              <div>
                                <h4>Air Time</h4>
                                { city.time }
                              </div>
                            }
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
              <div className='text-center'>
                { data.showfinderQuery.count > data.showfinderQuery.results.length &&
                  <button
                    type='button'
                    className='btn btn--load-more'
                    aria-label='Load More'
                    onClick={ getAll }
                  >
                    Show All
                  </button>
                }
              </div>
            </div>
          </>
        );
      }

      return(
        <div className='msg'>No Results Found</div>
      );
    }

    return(
      <div className='msg'>No Results Found</div>
    );
  }
}

export default LocationList;